import React from "react";
import { connect } from 'react-redux';
import Loading from '../components/moreComponents/Loading'
import { Range } from 'rc-slider';
import { Line} from "react-chartjs-2";
import _ from 'lodash'
import {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Progress,
  FormGroup,
  Input,
  ButtonGroup,
  Button,
} from "reactstrap";


import {dataDashboard,dataPerfResample} from 'variables/chartsData';
import {optionsDashboard,optionsPerfResample} from 'variables/chartsData';
import {runningIndexList} from '../helperFunctions/RunningIndex'
import {runningIndexMedian, month} from '../helperFunctions/RunningIndex'
import {runningIndexFeedback,distanceReadiness,distancePredictCalculate} from '../helperFunctions/RunningIndex'
import {fitFatForm, tssList} from '../helperFunctions/trainingLoadFunctions'
import {resampleTssMy,resamplePerformanceIndex} from '../helperFunctions/Resample';
import {resampleDistanceNoEnd} from '../helperFunctions/Resample';
import {distanceList,rollingDistance} from '../helperFunctions/analyticsFunctions'
import {metricDistance,metric} from '../helperFunctions/measurementSystem'

import PanelHeader from "components/PanelHeader/PanelHeader.js";

import NotificationAlert from "react-notification-alert";

import RedWatch from '../assets/img/exercise.svg'
import Heart from '../assets/img/heart.svg'
import Trend from '../assets/img/trend.svg'



class Dashboard extends React.Component {
  state = {timeframe:'linear',focus:'Default',sliderValue:[50,100]}

  notify(place,message) {
    if (!message){
      return ""
    }
    var color = message[0];
    if (color === "logout"){
      localStorage.clear()
      window.location.replace("/login")
    }
    var type;
    switch (color) {
      case 'success':
        type = "success";
        break;
      case 'danger':
        type = "danger";
        break;
      case 'warning':
        type = "warning";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div style={{height:'70px'}}>
            {message[1]}
          </div>
          
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53",
      autoDismiss: 10,
    };
    this.refs.notificationAlert.notificationAlert(options);
  }

  changeRange = (value) =>{
    clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(()=>{
        this.setState({sliderValue:value})
    }, 0);
  }
  componentDidMount(){
    if (!localStorage.getItem("token")){
      window.location.replace("/login")
    }
  }
  
  componentDidUpdate(prevProps){
    if(prevProps.message.message !== this.props.message.message && this.props.message.message){
      if (this.refs?.notificationAlert){
        this.notify("br",this.props.message.message)
      } 
    }
    if(prevProps.activities.entries !== this.props.activities.entries && this.props.activities.entries){
      this.setState({sliderValue:[50,100]})
    }
  }
  
  
  render() {
    if(!Array.isArray(this.props.activities.entries)){
      return(<div><Loading/></div>)
    }

    const measurementSystem = this.props.auth.measurementSystem
    //const loca  = localStorage.getItem('user')
    const activitiesSorted = this.props.activities.entries.sort((a, b) =>new Date(a.date) -new Date(b.date));
    const [runningIndex,dates]=runningIndexList(activitiesSorted)

    var [resampledPerfDate,resampledPerfIndex] = [[],[]]
    const max = Math.max.apply(null, runningIndex) 
    const min = Math.min.apply(null, runningIndex) 
    const [runningIndexMedianList,maxMedian,maxIndex,minMedian,minIndex] = runningIndexMedian(this.props.activities.entries)
    
    if (this.state.timeframe === "month"){
      
      [resampledPerfDate,resampledPerfIndex] = resamplePerformanceIndex(dates,runningIndex)
      
    }
   
    const chartColor = "#FFFFFF";
    const gradientFill = 'rgba(200, 200, 200, 0.2)';
    
    //console.log(this.state,parseFloat(max),parseFloat(min),parseFloat(maxMedian),parseFloat(minMedian))
    console.time("graphs")
    const options = optionsDashboard(max,min,maxMedian,minMedian,this.state.focus)
    const data = dataDashboard(dates,runningIndex,runningIndexMedianList,chartColor,gradientFill,this.state.sliderValue)
    
    const optionsBar = optionsPerfResample(max)
    const dataBar = dataPerfResample(resampledPerfDate,resampledPerfIndex,chartColor,gradientFill)
    console.timeEnd("graphs")
    
    //console.log("state is ",this.state.timeframe)
    var currentIndex = runningIndexMedianList[runningIndexMedianList.length-1]
    
    localStorage.setItem('runningIndex',currentIndex)
    const [classColor,feedbackRunningIndex] = runningIndexFeedback(currentIndex)
    
    
    //console.log(resampledPerfDate,resampledPerfIndex)
    ////training load ////
    
    
    const [tss,datesTss] = tssList(this.props.activities.entries)
    
    console.time("training load calc(resampleTss)")
    const [resampledDatesTss, resampledTss] = resampleTssMy(datesTss,tss)
    console.timeEnd("training load calc(resampleTss)")
    
    const [fitness,fatigue,form] = fitFatForm(resampledDatesTss, resampledTss)
    
    const currentFitness = fitness[fitness.length-61]
    const currentFatigue = fatigue[fatigue.length-61]
    const currentForm = form[form.length-61]
    localStorage.setItem('fitness',currentFitness)
    localStorage.setItem('fatigue',currentFatigue)
    localStorage.setItem('form',currentForm)
    
    
    var peakLoad = Math.max(...fitness)
    const peakLoadDate = resampledDatesTss[fitness.indexOf(peakLoad)];
    var datePeakLoad = new Date(peakLoadDate)
    datePeakLoad = String(datePeakLoad).split(" ")
    datePeakLoad = datePeakLoad[2]+" "+datePeakLoad[1]+" "+datePeakLoad[3]
    
    peakLoad = parseFloat(peakLoad).toFixed(2)
    //console.log("user : ",this.props.auth)
    
    const [duration5k,duration10k,duration21k,duration42k]=distancePredictCalculate(currentIndex,this.props.auth.rest_hr)
    const [duration5kPeak,duration10kPeak,duration21kPeak,duration42kPeak]=distancePredictCalculate(maxMedian,this.props.auth.rest_hr)
    //// Weekly mileage
    
    console.time("readiness")
    const [distance,dates2] = distanceList(this.props.activities.entries.filter(activity =>activity.activity_type === "Run"))
    const [resampledDates, resampledDistance] = resampleDistanceNoEnd(dates2,distance,"week")
    const fiveK = distanceReadiness(resampledDistance,5)
    const tenK = distanceReadiness(resampledDistance,10)
    const twentyOneK = distanceReadiness(resampledDistance,21)
    const marathon = distanceReadiness(resampledDistance,42)
    console.timeEnd("readiness")
    //console.log(fiveK,tenK,twentyOneK)
    var VO2max=(currentIndex*1.1175)-11.2879
    if(VO2max<0){
      VO2max = 0
    }

    console.time("rolling")
    var mileage = rollingDistance(dates2,distance)
    mileage = mileage[mileage.length-1]/1000
    mileage = metricDistance(mileage,measurementSystem)
    console.timeEnd("rolling")
    return (
      <>
      {this.state.timeframe === 'linear' ?
        <Row style={{height:'50%',marginTop:'50px'}}>
              <Line
                
                data={data}
                options={options}
              />
        </Row>
        : '' }
      {this.state.timeframe === 'month' ?
      
      <Row style={{height:'50%',marginTop:'50px'}}>
            
              <Line
                data={dataBar}
                options={optionsBar}
              />
           
        </Row>: '' } 
        <div className="content">
        <Range style={{marginTop:'30px',marginBottom:'20px'}} min={0} max={100} defaultValue={this.state.sliderValue} step={1} onChange={this.changeRange}/>
        <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
        </Row>
        
        <Row>
            
            <Col xs={12} md={4}>
                    
            </Col>
            <Col xs={12} md={4}>
                <FormGroup>
                    <ButtonGroup style={{width:'100%',backgroundColor:'rgb(30,30,30)',color:'rgb(100,100,200)'}}>
                      <Button style={{backgroundColor:'rgb(30,30,30)',color:'rgb(100,100,200)'}} onClick={()=>this.setState({focus:"Default"})}>Default</Button>
                      <Button style={{backgroundColor:'rgb(30,30,30)',color:'rgb(100,100,200)'}} onClick={()=>this.setState({focus:"Raw"})}>Raw</Button>
                      <Button style={{backgroundColor:'rgb(30,30,30)',color:'rgb(100,100,200)'}} onClick={()=>this.setState({focus:"Median"})}>Median</Button>
                    </ButtonGroup>
                  <Input style={{marginTop:'10px'}} className='text-info' type="select" value={this.state.timeframe} onChange={e => this.setState({timeframe:e.target.value})}>
                    <option value ='linear'>Linear</option>
                    <option value ='month'>By Month</option>
                    
                  </Input>
                </FormGroup>
            </Col>
            <Col xs={12} md={4}>
                
            </Col>
  
        </Row> 
        <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
        </Row>
        <Row>          
                <Col className="pl-4" md="12">
                    <hr></hr>
                </Col>
        </Row>
        {this.refs?.notificationAlert ? 
        <NotificationAlert ref="notificationAlert" /> 
        :
        " "}
        
        
          <Row>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(41, 67, 68)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category text-warning">Performance Index</h5>
                  <Row>
                    <Col xs={12} md={5}>
                      <CardTitle tag="h4">{parseFloat(currentIndex)?.toFixed(2)}</CardTitle>
                    </Col>
                    <Col xs={12} md={3}>
                      
                    </Col>
                    <Col xs={12} md={4}>
                      <img alt="" src={RedWatch} style={{height:'50px',width:'50px'}}></img>
                    </Col>
                  </Row>
                
                </CardHeader>
                
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span className={classColor}>{feedbackRunningIndex}</span>
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(18, 44, 36)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category text-warning">VO2max</h5>
                  <Row>
                    <Col xs={12} md={5}>
                      <CardTitle tag="h4">{parseFloat(VO2max)?.toFixed(2)}</CardTitle>
                    </Col>
                    <Col xs={12} md={3}>
                      
                    </Col>
                    <Col xs={12} md={4}>
                      <img alt="" src={Heart} style={{height:'50px',width:'50px'}}></img>
                    </Col>
                  </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> <span className={classColor}>{feedbackRunningIndex}</span>
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(25, 25, 25)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category text-warning">Last 4 Weeks</h5>
                  <Row>
                    <Col xs={12} md={7}>
                      <CardTitle tag="h4">{parseFloat(mileage)?.toFixed(2)} <span style={{color:'rgb(200,180,255)',fontSize:'15px'}}>{metric(measurementSystem)}</span></CardTitle>
                    </Col>
                    
                    <Col xs={12} md={4}>
                      <img alt="" src={Trend} style={{height:'50px',width:'50px'}}></img>
                    </Col>
                  </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,100,255)'}}/> ---
                  </div>
                </CardFooter>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                <CardHeader>
                  <h2 className="card-category text-info">Distance Readiness</h2>
                  <CardTitle tag="h4"></CardTitle>
                    <Row>
                      <Col xs={12} md={12}>
                        <div className="stats">
                            <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>5K  </label><label className='text-warning float-right' style={{fontSize:'13px'}}>{parseFloat(fiveK).toFixed(1)}%</label>
                            <Progress color="warning" value={fiveK} />
                        </div>
                        <div className="stats">
                        <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>10K  </label><label className='text-warning float-right' style={{fontSize:'13px'}}>{parseFloat(tenK).toFixed(1)}%</label>
                            <Progress color="warning" value={tenK} />
                        </div>
                        <div className="stats">
                        <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>21K </label><label className='text-warning float-right' style={{fontSize:'13px'}}>{parseFloat(twentyOneK).toFixed(1)}%</label>
                            <Progress color="warning" value={twentyOneK} />
                        </div>
                        <div className="stats">
                        <label style={{fontSize:'13px',color:'rgb(100,200,255)'}}>42K </label><label className='text-warning float-right' style={{fontSize:'13px'}}>{parseFloat(marathon).toFixed(1)}%</label>
                            <Progress color="warning" value={marathon} />
                        </div>
                  
                      </Col>
                      
          
                    </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    
                  </div>
                </CardFooter>
              </Card>
            </Col>
                
            <Col xs={12} md={4}>
              
            </Col>
          </Row>
          <Row>
          <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(25, 25, 25)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category text-warning">Peak performance index</h5>
                  <Row>
                    <Col xs={12} md={7}>
                      <CardTitle tag="h4">{maxMedian} </CardTitle>
                    </Col>
                    
                    <Col xs={12} md={4}>
                      
                    </Col>
                  </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,255,255)'}}/> {dates[maxIndex] ? month(dates[maxIndex]) : '--'}
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="card-chart" style={{backgroundColor: 'rgb(25, 25, 25)',color: '#FFFFFF'}}>
                <CardHeader>
                  <h5 className="card-category text-warning">Peak training load</h5>
                  <Row>
                    <Col xs={12} md={7}>
                      <CardTitle tag="h4">{peakLoad} </CardTitle>
                    </Col>
                    
                    <Col xs={12} md={4}>
                      
                    </Col>
                  </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    <i className="now-ui-icons media-2_sound-wave" style={{color:'rgb(100,255,255)'}}/> {datePeakLoad}
                  </div>
                </CardFooter>
              </Card>
            </Col>
            
          </Row>
          <Row>
            <Col xs={12} md={12}>
              <Card className="card-chart" style={{backgroundColor: '#444444',color: '#FFFFFF'}}>
                <CardHeader>
                  <h2 className="card-category text-info">Race Prediction</h2>
                  <CardTitle tag="h4"></CardTitle>
                    <Row>
                      <Col xs={6} md={6}>
                        <div className="stats">
                          <h4>Current</h4>
                        </div>
                        <div className="stats">
                            <label>5K  </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(100,255,255)',fontSize:'25px'}}>{duration5k}</span></CardTitle>
                        </div>
                        <div className="stats">
                            <label>10K </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(100,255,255)',fontSize:'25px'}}>{duration10k}</span></CardTitle>
                        </div>
                        <div className="stats">
                            <label>21K </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(100,255,255)',fontSize:'25px'}}>{parseFloat(twentyOneK).toFixed(1)>50 ? duration21k : '--'}</span></CardTitle>
                        </div>
                        <div className="stats">
                            <label>42K </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(100,255,255)',fontSize:'25px'}}>{parseFloat(marathon).toFixed(1)>50 ? duration42k : '--'}</span></CardTitle>
                        </div>
                  
                      </Col>
                      <Col xs={6} md={6}>
                        <div className="stats">
                          <h4>Peak perf.</h4>
                        </div>
                        <div className="stats">
                            <label>5K  </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(255,200,100)',fontSize:'25px'}}>{duration5kPeak}</span></CardTitle>
                        </div>
                        <div className="stats">
                            <label>10K </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(255,200,100)',fontSize:'25px'}}>{duration10kPeak}</span></CardTitle>
                        </div>
                        <div className="stats">
                            <label>21K </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(255,200,100)',fontSize:'25px'}}>{parseFloat(twentyOneK).toFixed(1)>50 ? duration21kPeak : '--'}</span></CardTitle>
                        </div>
                        <div className="stats">
                            <label>42K </label>
                            <CardTitle tag="h4"> <span style={{color:'rgb(255,200,100)',fontSize:'25px'}}>{parseFloat(marathon).toFixed(1)>50 ? duration42kPeak : '--'}</span></CardTitle>
                        </div>
                  
                      </Col>
                      
          
                    </Row>
                </CardHeader>
               
                <CardFooter>
                  <div className="stats">
                    
                  </div>
                </CardFooter>
              </Card>
            </Col>
                
            <Col xs={12} md={4}>
              
            </Col>
          </Row>
        
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log("map",state)
  return {activities:state.activities,message:state.message,auth:state.auth}
}

export default connect(mapStateToProps)(Dashboard);